import { type Component, type JSX, Show } from 'solid-js';
import { ShieldAlert } from 'lucide-solid';
import { Button } from '~/shared/ui/Button';
import { sectionLabel } from './section-access';

export const NoAccessPage: Component<{ section: string; onHome: () => void }> = (props) => (
  <div class="flex min-h-[60vh] items-center justify-center p-8" role="alert">
    <div class="max-w-md text-center">
      <ShieldAlert class="mx-auto h-8 w-8 text-tertiary" />
      <p class="mt-3 text-[17px] font-semibold text-primary">Нет доступа к разделу «{sectionLabel(props.section)}»</p>
      <p class="mt-2 text-[14px] text-secondary">
        Обратитесь к владельцу клуба: права сотрудников настраиваются в разделе «Сотрудники» и в «Настройки → Доступ
        и безопасность».
      </p>
      <div class="mt-6">
        <Button variant="secondary" onClick={() => props.onHome()}>
          На главную
        </Button>
      </div>
    </div>
  </div>
);

export const SectionGate: Component<{
  pathname: string;
  denied: string | null;
  forbiddenAt: string | null;
  section: string | null;
  onHome: () => void;
  children: JSX.Element;
}> = (props) => {
  const closed = () =>
    props.denied ?? (props.forbiddenAt !== null && props.forbiddenAt === props.pathname
      ? (props.section ?? props.pathname)
      : null);
  return (
    <Show when={closed()} fallback={props.children}>
      {(section) => <NoAccessPage section={section()} onHome={props.onHome} />}
    </Show>
  );
};
